import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import { DownloadGroupName } from '../../DownloadManager/reducer';
import RoutesUtils from '../../../utils/routes';
import { DriveItemListOrigin } from '../../DriveItemListPage/constants';
import { hashHistory } from 'react-router';
import Content from '../../../components/DownloadGroupToast/Content';
import DownloadManagerUtils from '../../../utils/downloadManager';
import { downloadAll, downloadImportantAssets } from '../../DownloadManager/actions';
import { downloadSelectedAssets } from '../../DownloadManager/actions/download';
import { finishDownloadGroup, resetSelectedDownloadItems } from '../../DownloadManager/actions/store';

const mapStateToProps = (state: StoreState) => {
	const {
		downloadManager: {
			downloadGroups,
		},
		routerParamsHistory,
	} = state;
	const currentOrigin = RoutesUtils.getCurrentOrigin(routerParamsHistory);
	const isDownloadsFolder = currentOrigin === DriveItemListOrigin.Downloads;
	const startedDownloadGroup = DownloadManagerUtils.getStartedDownloadGroup(downloadGroups);
	const downloadingGroup = DownloadManagerUtils.getDownloadingGroup(downloadGroups);
	const isDownloading = downloadingGroup !== null;
	const linkToDownloadsPage = isDownloadsFolder
		? undefined
		: `#${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Downloads, null)}${hashHistory.getCurrentLocation().search}`;
	const message = getMessage(downloadingGroup, startedDownloadGroup);

	return {
		isDownloading,
		message,
		linkToDownloadsPage,
		startedDownloadGroup,
	};
};


const getMessage = (downloadingGroup: DownloadGroupName | null, startedDownloadGroup: DownloadGroupName | null): string => {
	if (downloadingGroup === DownloadGroupName.ALL) {
		return 'messages.download_all_toast_in_progress';
	}

	if (downloadingGroup === DownloadGroupName.IMPORTANT) {
		return 'messages.download_importants_toast_in_progress';
	}

	if (downloadingGroup === DownloadGroupName.SELECTED) {
		return 'messages.download_selected_toast_in_progress';
	}

	if (startedDownloadGroup === DownloadGroupName.ALL) {
		return 'messages.download_all_toast_paused';
	}

	if (startedDownloadGroup === DownloadGroupName.IMPORTANT) {
		return 'messages.download_importants_toast_paused';
	}

	if (startedDownloadGroup === DownloadGroupName.SELECTED) {
		return 'messages.download_selected_toast_paused';
	}

	return '';
};

interface OwnProps {
	onContinueClick?: () => void;
	onCancelClick?: () => void;
	isCheckingForUpdates?: boolean;
}

interface StateProps {
	isDownloading: boolean;
	message: string;
	linkToDownloadsPage: string | undefined;
	startedDownloadGroup: DownloadGroupName | null;
}

interface DispatchProps {
	onContinueClick: () => void;
	onCancelClick: () => void;
	isCheckingForUpdates: boolean;
}

const mapDispatchToProps = (dispatch: Dispatch<StoreState>, ownProps: OwnProps & StateProps): DispatchProps => {
	const { startedDownloadGroup, onContinueClick: parentOnContinueClick, onCancelClick: parentOnCancelClick, isCheckingForUpdates } = ownProps;

	// If parent provides handlers, use them; otherwise use our own
	return {
		isCheckingForUpdates: isCheckingForUpdates || false,
		onContinueClick: parentOnContinueClick || (() => {
			switch (startedDownloadGroup) {
				case DownloadGroupName.IMPORTANT:
					dispatch(downloadImportantAssets());
					break;
				case DownloadGroupName.ALL:
					dispatch(downloadAll());
					break;
				case DownloadGroupName.SELECTED:
					dispatch(downloadSelectedAssets());
					break;
				default:
					break;
			}
		}),
		onCancelClick: parentOnCancelClick || (() => {
			switch (startedDownloadGroup) {
				case DownloadGroupName.IMPORTANT:
					dispatch(finishDownloadGroup(DownloadGroupName.IMPORTANT));
					break;
				case DownloadGroupName.ALL:
					dispatch(finishDownloadGroup(DownloadGroupName.ALL));
					break;
				case DownloadGroupName.SELECTED:
					dispatch(resetSelectedDownloadItems());
					break;
				default:
					break;
			}
		}),
	};
};

export default connect<StateProps, DispatchProps, OwnProps, StoreState>(mapStateToProps, mapDispatchToProps)(Content);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadGroupToast/Content/index.tsx